<template>
  <WrongTenantRedirectModal />
  <DynamicModal />
  <SettingTeamsModal />
  <DeviceSettingModal />
  <LoadingPage v-if="appView === AppView.Blank" />
  <NotFoundPage v-else-if="appView === AppView.NotFound" />
  <MainLayout v-else-if="appView === AppView.UnAuthorized">
    <template v-slot:header>
      <AppHeader :title="siteTitle" />
    </template>
    <AccessDeniedPage />
    <template v-slot:footer>
      <AppFooter />
    </template>
  </MainLayout>
  <MainLayout v-else>
    <CookieConsentBanner />
    <template v-if="isHeaderVisible" v-slot:header>
      <AppHeader :title="siteTitle" />
    </template>
    <BlockedBrowser v-if="isBrowserBlocked" :is-desktop="isDesktopBrowser" />
    <router-view v-else :key="$route.fullPath" />
    <div v-if="isMaskGrandAccess" class="mask-grand-access">
      <Spin class="ant-custom-home" />
    </div>
    <LostConnectionWarning />
    <template v-if="isFooterVisible" v-slot:footer>
      <AppFooter />
    </template>
  </MainLayout>
  <Toast></Toast>
  <div class="fixed bottom-1 right-2 text-[10px] text-gray-400 font-sans z-50 select-none pointer-events-none">
    {{ versionUpdatedText }}
  </div>
</template>
<script lang="ts" src="./app.ts" />
<style lang="scss" src="./app.scss" />
